var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "wrapper", staticClass: "tag-cloud" },
    _vm._l(_vm.data, function(item, index) {
      return _c("span", {
        key: index,
        ref: "tag",
        refInFor: true,
        staticClass: "p",
        staticStyle: {
          display: "flex",
          padding: "10px",
          "justify-content": "center",
          "align-items": "center"
        },
        on: {
          click: function($event) {
            return _vm.clickTag(item)
          },
          dblclick: function($event) {
            return _vm.dbclickTag(item)
          }
        }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee5b67ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee5b67ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/extract/tagCloud.vue
// module id = null
// module chunks = 